import { render, staticRenderFns } from "./membre-update-dialog.vue?vue&type=template&id=61bf5048&scoped=true"
import script from "./membre-update-dialog.vue?vue&type=script&lang=js"
export * from "./membre-update-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bf5048",
  null
  
)

export default component.exports